import React from 'react';
import style from "./Friends.module.css";
import Friend from "./Friend/Friend";

function createCard(data) {
    return (
        <Friend
            id={data.id}
            key={data.id}
            bgImg={data.bgURL}
            followers={data.followers}
            name={data.name}
            location={data.location}
            img={data.imgURL}
            friends={data.friends}
            photos={data.photos}
            posts={data.posts}
            videos={data.videos}
            since={data.since}
        />
    );
}
const Friends = (props) => {
    let friendFollow = props.usersPage.users.filter(function (user){ return user.followed === true});
    let friendList = friendFollow.map(createCard);

    return (
        <div className={style.friendsPage}>
            {friendList};
        </div>
    );
};

export default Friends;